import { ImgHTMLAttributes } from 'react'
import { createComponent } from '@lair-finance/util'
import { getIconPath, getImagePath } from '@/shared/lib/utils/asset.ts'

export type AssetProps = Omit<ImgHTMLAttributes<HTMLImageElement>, 'src'> & {
  filename: string
  directory?: string
  size?: number
}

export const AssetIcon = createComponent<HTMLImageElement, AssetProps>(
  ({ filename, directory, size, ...props }, ref) => (
    <img src={getIconPath(filename, directory)} ref={ref} {...props} width={size || props.width} height={size || props.height} />
  ),
  'AssetIcon',
)

export const AssetImage = createComponent<HTMLImageElement, AssetProps>(
  ({ filename, directory, size, ...props }, ref) => (
    <img src={getImagePath(filename, directory)} ref={ref} {...props} width={size || props.width} height={size || props.height} />
  ),
  'AssetImage',
)
